/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import type {
  AppointmentContextClient,
  AppointmentDisplayStatus,
  AppointmentStatus,
  CustomDurationBody,
  CustomPriceBody,
  FixedDurationBody,
  FixedPriceBody,
  FlexibleDurationBody,
  FromPriceBody,
  InteractionType,
  LastMessage,
  MessagePlatform,
  MessageRole,
  MessageType,
  RangeDurationBody,
  RangePriceBody,
  SenderType,
  ServiceFormat,
  WorkTimeType,
} from './types';

export type AppointmentServiceSnapshotDto = {
  name: string;
  serviceId: string;
  category?: string | null;
  description?: string | null;
  duration?: CustomDurationBody | FixedDurationBody | FlexibleDurationBody | RangeDurationBody | null;
  format?: ServiceFormat | null;
  interactionType?: InteractionType | null;
  preMeetingQuestions?: string | null;
  price?: CustomPriceBody | FixedPriceBody | FromPriceBody | RangePriceBody | null;
};

export type AppointmentEventData = {
  _id: string;
  client: AppointmentContextClient;
  createdAt: string;
  displayStatus: AppointmentDisplayStatus;
  endTime: string;
  lifecycleStatus: AppointmentStatus;
  masterId: string;
  services: AppointmentServiceSnapshotDto[];
  slotId: string;
  startTime: string;
  totalDuration: CustomDurationBody | FixedDurationBody | FlexibleDurationBody | RangeDurationBody;
  totalPrice: CustomPriceBody | FixedPriceBody | FromPriceBody | RangePriceBody;
  updatedAt: string;
  workTimeType: WorkTimeType | null;
};

export type AppointmentEvent = {
  appointment: AppointmentEventData;
};

export type AppointmentStatusChangedData = {
  _id: string;
  client: AppointmentContextClient;
  createdAt: string;
  displayStatus: AppointmentDisplayStatus;
  endTime: string;
  lifecycleStatus: AppointmentStatus;
  masterId: string;
  previousLifecycleStatus: AppointmentStatus;
  services: AppointmentServiceSnapshotDto[];
  slotId: string;
  startTime: string;
  totalDuration: CustomDurationBody | FixedDurationBody | FlexibleDurationBody | RangeDurationBody;
  totalPrice: CustomPriceBody | FixedPriceBody | FromPriceBody | RangePriceBody;
  updatedAt: string;
  workTimeType: WorkTimeType | null;
};

export type AppointmentStatusChanged = {
  appointment: AppointmentStatusChangedData;
};

export type MessageSender = {
  id: string;
  senderType: SenderType;
  avatar?: string;
  firstName?: string;
  lastName?: string;
};

export type MessageData = {
  content: string;
  conversation: string;
  id: string;
  messageType: MessageType;
  platform: MessagePlatform;
  role: MessageRole;
  senderType: SenderType;
  timestamp: string;
  sender?: MessageSender;
};

export type NewMessageConversationUpdates = {
  lastMessage?: LastMessage;
  unansweredCount?: number;
  unreadCount?: number;
};

export type NewMessage = {
  conversationId: string;
  conversationUpdates: NewMessageConversationUpdates;
  message: MessageData;
};

export type ConversationCreated = {
  conversationId: string;
};

export type ConversationUpdatedFields = {
  lastMessageAt?: string;
  lastMessageContent?: string;
  unansweredCount?: number;
  unreadCount?: number;
};

export type ConversationUpdated = {
  conversationId: string;
  updates: ConversationUpdatedFields;
};

export type OnboardingSmartIgProgress = {
  smartOnboardingInProgress: boolean;
  state: string;
  message?: string;
  progress?: number;
  screen?: string;
};

export type OnboardingSmartIgFinished = {
  smartOnboardingInProgress: boolean;
  message?: string;
};

export type OnboardingSmartIgAborted = {
  smartOnboardingInProgress: boolean;
};
export const ServerEvent = {
  APPOINTMENT_PENDING: 'appointment_pending',
  APPOINTMENT_STATUS_CHANGED: 'appointment_status_changed',
  CONVERSATION_CREATED: 'conversation_created',
  CONVERSATION_UPDATED: 'conversation_updated',
  NEW_APPOINTMENT: 'new_appointment',
  NEW_MESSAGE: 'new_message',
  ONBOARDING_SMART_IG_ABORTED: 'onboarding:smart_ig_aborted',
  ONBOARDING_SMART_IG_FINISHED: 'onboarding:smart_ig_finished',
  ONBOARDING_SMART_IG_PROGRESS: 'onboarding:smart_ig_progress',
} as const;

export type ServerEvent = (typeof ServerEvent)[keyof typeof ServerEvent];

export type SocketEventMap = {
  [ServerEvent.APPOINTMENT_PENDING]: AppointmentEvent;
  [ServerEvent.APPOINTMENT_STATUS_CHANGED]: AppointmentStatusChanged;
  [ServerEvent.CONVERSATION_CREATED]: ConversationCreated;
  [ServerEvent.CONVERSATION_UPDATED]: ConversationUpdated;
  [ServerEvent.NEW_APPOINTMENT]: AppointmentEvent;
  [ServerEvent.NEW_MESSAGE]: NewMessage;
  [ServerEvent.ONBOARDING_SMART_IG_ABORTED]: OnboardingSmartIgAborted;
  [ServerEvent.ONBOARDING_SMART_IG_FINISHED]: OnboardingSmartIgFinished;
  [ServerEvent.ONBOARDING_SMART_IG_PROGRESS]: OnboardingSmartIgProgress;
};
